import React from 'react';
import styled from 'styled-components';

const PatternRepeat = ({ item }) => {
    const RepeatContainer = styled.div`
        display: flex;
        flex-wrap: wrap;
        position: absolute;
        top: 0;
        left: 0;
    `;

    const RepeatItem = styled.div`
        width: 33%;
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        line-height: 0;
    `;

    return (
        <RepeatContainer>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
            <RepeatItem>
                {item}
            </RepeatItem>
        </RepeatContainer>
    );
};

export default PatternRepeat;



// WEBPACK FOOTER //
// ./src/components/patterngalleries/PatternRepeat.js